import { sessionPrefix } from "./helpers";

export const pipelinesPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/pipelines`;
